import React from 'react';
import './About.css';

const About = ({ author }) => {
  // Feltételezzük, hogy a db.json-ben a profileImage már a valódi képedre mutat
  // pl. "profileImage": "/images/logan-reid-parker-portre.jpg"
  const profileImage = author.profileImage || '/images/author-placeholder.jpg';

  return (
    <div className="about-container">
      <div className="about-content">

        {/* 1. KÉP SZEKCIÓ */}
        <div className="about-image-wrapper">
          <img src={profileImage} alt={author.name} className="author-image" />
        </div>

        {/* 2. SZÖVEGES SZEKCIÓ */}
        <div className="about-text">
          <h2 className="about-title">A TÚLÉLŐ</h2>
          <h1 className="author-name">{author.name}</h1>
          
          <div className="author-bio">
            {/* A bio tömböt bekezdésekre bontjuk */}
            {author.bio.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
        
      </div>
    </div>
  );
};

export default About;